import React, { useState, useEffect, Children } from 'react'
import SidebarProposal from '../../layouts/sidebarProposal/SidebarProposal'
import ErrorWidget from '../../widgets/errorWidget/ErrorWidget'
import PanalLoadingTemplate from '../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import { startLoading, doneLoading } from '../../utils/loading'
import ContentHeader from '../../components/ContentHeader/ContentHeader'
import { getImportNodePage } from '../../redux/actions/assessment'
import ImportNodeDataWidgets from '../../widgets/assessment/ImportNodeDataWidgets'

export default function ImportNodeData() {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()

  useEffect(() => {
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()

    try {
      const response = await getImportNodePage(1, 5)
      setSchema(response)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }

    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal isAssessment>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isAssessment>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <SidebarProposal isAssessment>
      <ContentHeader header={schema.header} isNotCallApi />
      {schema && <ImportNodeDataWidgets schema={schema}/>}
    </SidebarProposal>
  )
}

const mocSchema = {
  header: 'นำเข้าข้อมูล Node',
  // searchForm: [
  //   {
  //     name: 'budgetYear',
  //     label: 'ปีงบประมาณ',
  //     type: '1',
  //   },
  //   {
  //     name: 'email',
  //     label: 'email',
  //     type: '1',
  //   },
  //   {
  //     name: 'startDate',
  //     label: 'วันที่เริ่มต้น',
  //     type: '3',
  //   },
  //   {
  //     name: 'endDate',
  //     label: 'วันที่สิ้นสุด',
  //     type: '3',
  //   },
  // ],
  resultData: {
    total: 10,
    values : [
      {
        projectCode: '66-00057-15',
        node: 'Node จังหวัด',
        budgetYear: 2566,
        budget: 60000,
        projectName: 'center',
      },
      {
        projectCode: '66-00057-16',
        node: 'Node จังหวัด',
        budgetYear: 2566,
        budget: 60000,
        projectName: 'center',
      },
      {
        projectCode: '66-00053-17',
        node: 'Node จังหวัด',
        budgetYear: 2566,
        budget: 60000,
        projectName: 'center',
      },
      {
        projectCode: '66-00053-18',
        node: 'Node จังหวัด',
        budgetYear: 2566,
        budget: 60000,
        projectName: 'center',

      },
    ],
  }
}
